import React, {useContext} from 'react';
import clsx from 'clsx';
import AuthContext from '../../context/authContext/authContext';
import {useHistory} from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import {AppBar,
       Toolbar,
       IconButton,
      
       Button
            } from '@material-ui/core';



const useStyle = makeStyles((theme)  =>({
   
    menuButton : {
        marginRight : theme.spacing(3)
    },
    title: {
       width : '100%',
       display : 'flex',
       alignItems :'center',
       justifyContent : 'space-between'
       
    },
    menu : {
      flexGrow : 1
    },
    navBar : {
        display : 'flex',
        justifyContent : 'space-between',
        alignItems: 'center',
    
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          
    },
    appBarShift: {
        width: `calc(100% - 240px)`,
        marginLeft: 240,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    hide: {
        display: 'none',
    },
    
}));


const NavBarAdmin = (props) => {
  //PROPS
  const {open ,setopen} = props
  const history = useHistory()
  const authContext = useContext(AuthContext);
    const {
            logOut,
            
        } = authContext; 
    const cerrarSesion = () => {
      logOut()
      history.push('/')

    }
    const classes = useStyle();
    return ( 
      <div>
        <AppBar position="fixed" className = {clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}>
            <Toolbar >
              <div className = {classes.title}>
                <div className = {classes.menu}>
                <IconButton 
                        edge="start" 
                        color="inherit" 
                        aria-label="menu" 
                        className={clsx(classes.menuButton, open && classes.hide)}
                        onClick = {() => setopen(!open)}>
                        <MenuIcon />
                    </IconButton>
                <Button color='inherit'  onClick={() => history.push('/admin/salon')}  >
                        Pila Cerveceria
                </Button>
                </div>
                <div>
                  <Button onClick={() => cerrarSesion()} color="inherit">Cerrar Sesion</Button>
                </div>
              </div>
               
               
            </Toolbar>
            
        </AppBar>
    
       
     </div>
  );
}
 
export default NavBarAdmin;
